<template>
  <div class="row custom-mobile">
    <div class="col-xxl-3 col-sm-6 card-custom-mobile">
      <div class="card mb-none mb-sm-none mb-md-25 md-lg-25 md-xl-25 md-xxl-25 border-0 radius-7 bg-white stats-item">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing heigth-cards-recordings">
          <div class="d-flex align-items-center justify-content-between">
            <div
              class="icon position-relative text-primary rounded-1 text-center icon-custom-mobile"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title text-end custom-title-mobile">
              <span class="d-block fw-bold text-dark-emphasis mb-5 custom-size-title-mobile">
                UPLOADS COM SUCESSO
              </span>
              <div class="d-flex align-items-center justify-content-end">
                <h3 class="fw-black mb-0 me-10">{{ getRecordingsCards.total_success }}</h3>
              </div>
            </div>
          </div>
          <div
            class="mt-15 mt-md-25 mb-5 mb-md-8 d-flex justify-content-between align-items-center"
          >
            <span class="fw-medium text-secondary custom-size-title-mobile">
              Porcentagem
            </span>
            <span class="text-success fw-semibold">{{ getRecordingsCards.percentage_success }}%</span>
          </div>
          <div
            class="progress"
            role="progressbar"
            aria-valuenow="38"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div class="progress-bar bg-success" :style="{ width: getRecordingsCards.percentage_success + '%' }"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xxl-3 col-sm-6 card-custom-mobile">
      <div class="card mb-none mb-sm-none mb-md-25 md-lg-25 md-xl-25 md-xxl-25 border-0 radius-7 bg-white stats-item">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing heigth-cards-recordings">
          <div class="d-flex align-items-center justify-content-between">
            <div
              class="icon position-relative text-success rounded-1 text-center icon-custom-mobile"
            >
              <i class="flaticon-sugar-cubes"></i>
            </div>
            <div class="title text-end custom-title-mobile">
              <span class="d-block fw-bold text-dark-emphasis mb-5 custom-size-title-mobile">
                UPLOADS COM ERRO
              </span>
              <div class="d-flex align-items-center justify-content-end">
                <h3 class="fw-black mb-0 me-10">{{ getRecordingsCards.total_error }}</h3>
              </div>
            </div>
          </div>
          <div
            class="mt-15 mt-md-25 mb-5 mb-md-8 d-flex justify-content-between align-items-center"
          >
            <span class="fw-medium text-secondary custom-size-title-mobile">
              Porcentagem
            </span>
            <span class="font-red fw-semibold">{{ getRecordingsCards.percentage_error }}%</span>
          </div>
          <div
            class="progress"
            role="progressbar"
            aria-valuenow="42"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div class="progress-bar bg-red" :style="{ width: getRecordingsCards.percentage_error + '%' }"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xxl-3 col-sm-6 card-custom-mobile row-bottom-custom-mobile">
      <div class="card mb-none mb-sm-none mb-md-25 md-lg-25 md-xl-25 md-xxl-25 border-0 radius-7 bg-white stats-item">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing heigth-cards-recordings">
          <div class="d-flex align-items-center justify-content-between">
            <div class="icon position-relative text-info rounded-1 text-center icon-custom-mobile">
              <i class="flaticon-idea"></i>
            </div>
            <div class="title text-end custom-title-mobile">
              <span class="d-block fw-bold text-dark-emphasis mb-5 custom-size-title-mobile">
                TEMPO TOTAL
              </span>
              <div class="d-flex align-items-center justify-content-end result-custom-mobile">
                <h3 class="fw-black mb-0 me-none me-sm-none me-lg-10 me-xl-10 me-xxl-10">{{ convertTime(getRecordingsCards.total_time) }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xxl-3 col-sm-6 card-custom-mobile row-bottom-custom-mobile">
      <div class="card mb-3 border-0 radius-7 bg-white stats-item">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing heigth-cards-recordings">
          <div class="d-flex align-items-center justify-content-between">
            <div
              class="icon position-relative text-danger rounded-1 text-center icon-custom-mobile"
            >
              <i class="flaticon-user-3"></i>
            </div>
            <div class="title text-end custom-title-mobile">
              <span class="d-block fw-bold text-dark-emphasis mb-5 custom-size-title-mobile">
                TAMANHO TOTAL
              </span>
              <div class="d-flex align-items-center justify-content-end result-custom-mobile">
                <h3 class="fw-black mb-0 me-none me-sm-none me-lg-10 me-xl-10 me-xxl-10">{{ (getRecordingsCards.total_size / (1024 * 1024)).toFixed(2) + " MB" }}</h3>
              </div>
            </div>
          </div>
          <div class="mt-15 mt-md-20 users-list d-flex align-items-center icon-custom-mobile">
            <div class="rounded-circle bg-primary-emphasis text-center d-flex align-items-center justify-content-center text-white fs-16 space-between-options-files-card-recording">
              wav
            </div>
            <div class="rounded-circle bg-info text-center d-flex align-items-center justify-content-center text-white fs-16 space-between-options-files-card-recording">
              gsm
            </div>
            <div class="rounded-circle bg-primary text-center d-flex align-items-center justify-content-center text-white fs-16 space-between-options-files-card-recording">
              mp3
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "StatsItem",
  methods: {
    convertTime(time: number | string) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0)); // lida com "96000.01243"
      const d = moment.duration(totalSeconds, 'seconds');

      const hours = Math.floor(d.asHours()); // horas **totais**, não %24
      const minutes = d.minutes();
      const seconds = d.seconds();

      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`; // ex.: 26:40:00
    }
  },
  computed:{
    ...mapGetters([
      'getRecordingsCards'
    ])
  },
});
</script>

<style scoped>

@media (max-width: 768px) {
  .custom-mobile{
    display: grid;
    grid-template-columns: 48% 48%;
    width: calc(100vw - 32px);
    margin-left: auto;
    margin-right: auto;
    justify-items: center;
    justify-content: space-between;
  }

  .card-custom-mobile{
    padding-right: unset;
    padding-left: unset;
  }

  .custom-size-title-mobile{
    font-size: 8pt !important;
  }

  .heigth-cards-recordings{
    height: fit-content !important;
  }

  .row-bottom-custom-mobile{
    margin-top: 15px;
  }

  .custom-title-mobile{
    text-align: center !important;
    width: 100% !important;
  }

  .result-custom-mobile{
    justify-content: center !important;
  }

  .icon-custom-mobile{
    display: none !important;
  }
}
</style>